import { render, staticRenderFns } from "./ErroDlg.vue?vue&type=template&id=1c1b2fed"
import script from "./ErroDlg.vue?vue&type=script&lang=js"
export * from "./ErroDlg.vue?vue&type=script&lang=js"
import style0 from "./ErroDlg.vue?vue&type=style&index=0&id=1c1b2fed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports